"use client";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { DialogProps } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { useState } from "react";
import useLandingPageInvite from "@/hooks/client/useLandingPageInvite";
import { isValidEmail } from "@/lib/utils";

const WaitlistFormModal: React.FC<DialogProps> = ({
  onOpenChange,
  ...props
}) => {
  const [emailAddress, setEmailAddress] = useState("");
  const { joinWaitlist, loading } = useLandingPageInvite();

  const isValid = isValidEmail(emailAddress);

  return (
    <Dialog onOpenChange={onOpenChange} {...props}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Join Gondola</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center justify-center gap-4 py-1">
          <Input
            type="email"
            placeholder="Email Address"
            className="h-[40px] w-full max-w-[400px] bg-background"
            value={emailAddress}
            onChange={(e) => setEmailAddress(e.target.value.toLowerCase())}
          />
          <Button
            onClick={() => joinWaitlist(emailAddress)}
            className=""
            loading={loading}
            disabled={!isValid}
          >
            Get Started
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WaitlistFormModal;
